import React from 'react';
import GameQuery from '../../query/GameQuery';
import CashFlowStatement from '../../components/CashFlowStatement';
import { Route } from 'react-router-dom';
import { CASHFLOW } from '../../routes';

const CashFlowStatementRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={CASHFLOW}
				render={props => <CashFlowStatement {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default CashFlowStatementRoute;
